import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function OneFoldPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-[#b8144a] to-[#d91e5b] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-6">One Fold Network</h1>
          <p className="text-xl max-w-4xl mx-auto">
            A global discipleship network raising sons and daughters through intentional spiritual formation (2 Timothy 2:2)
          </p>
        </div>
      </section>

      {/* What is One Fold Network */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Leadership Formation Network</h2>
              <div className="prose prose-lg text-gray-700">
                <p className="text-xl leading-relaxed mb-6">
                  One Fold Network (OFN) is the leadership development arm of Peter Akinnubi Apostolic Mandate, 
                  specifically designed to raise spiritual sons and daughters through intentional discipleship 
                  and apostolic formation.
                </p>
                <p className="text-lg leading-relaxed mb-6">
                  Following the biblical pattern of 2 Timothy 2:2, OFN creates a systematic approach to 
                  spiritual reproduction, where faithful men and women are equipped to teach others also. 
                  This network forms the leadership structures of the MANDATE across all nine strategic programs.
                </p>
                <blockquote className="text-lg italic text-[#b8144a] border-l-4 border-[#b8144a] pl-6 my-6">
                  "And the things that you have heard from me among many witnesses, commit these to faithful men 
                  who will be able to teach others also." - 2 Timothy 2:2
                </blockquote>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Spiritual%20mentorship%20and%20discipleship%20training%20with%20diverse%20group%20of%20emerging%20leaders%20studying%20together%2C%20apostolic%20leadership%20development%20session%20with%20mentor%20teaching%20disciples%2C%20biblical%20leadership%20formation%20with%20warm%20lighting%20and%20inspiring%20atmosphere%2C%20representing%20spiritual%20sons%20and%20daughters%20being%20raised%20in%20ministry&width=600&height=500&seq=one-fold-network-1&orientation=landscape"
                alt="One Fold Network Leadership Development"
                className="rounded-lg shadow-2xl object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Leadership Development Levels */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Leadership Development Levels</h2>
            <p className="text-xl text-gray-600">Progressive formation from disciple to leader</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-xl font-bold">1</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Emerging Disciple</h3>
              <p className="text-gray-700 mb-4">
                New believers completing GMTP and beginning their journey in spiritual formation
              </p>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Basic doctrine training</li>
                <li>• Spiritual disciplines</li>
                <li>• Character development</li>
                <li>• Ministry exposure</li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-xl font-bold">2</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Growing Leader</h3>
              <p className="text-gray-700 mb-4">
                Disciples showing leadership potential and receiving advanced training and mentorship
              </p>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Leadership principles</li>
                <li>• Team building skills</li>
                <li>• Ministry assignments</li>
                <li>• Pastoral care training</li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-xl font-bold">3</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Established Minister</h3>
              <p className="text-gray-700 mb-4">
                Proven leaders ready to take on significant ministry responsibilities and mentor others
              </p>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Ministry leadership</li>
                <li>• Discipleship training</li>
                <li>• Church planting</li>
                <li>• Regional oversight</li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-xl font-bold">4</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Apostolic Leader</h3>
              <p className="text-gray-700 mb-4">
                Mature leaders with apostolic calling, capable of establishing and overseeing networks
              </p>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Network establishment</li>
                <li>• Apostolic oversight</li>
                <li>• International ministry</li>
                <li>• Movement multiplication</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Formation Process */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Spiritual Formation Process</h2>
            <p className="text-xl text-gray-600">Comprehensive development of character, competence, and calling</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-white text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Character Formation</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-[#b8144a] mt-1"></i>
                  <span>Christlike character development</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-[#b8144a] mt-1"></i>
                  <span>Integrity and accountability</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-[#b8144a] mt-1"></i>
                  <span>Spiritual disciplines</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-[#b8144a] mt-1"></i>
                  <span>Emotional maturity</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-tools-line text-white text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Competence Building</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-[#b8144a] mt-1"></i>
                  <span>Biblical knowledge and interpretation</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-[#b8144a] mt-1"></i>
                  <span>Ministry skills development</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-[#b8144a] mt-1"></i>
                  <span>Leadership capabilities</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-[#b8144a] mt-1"></i>
                  <span>Communication excellence</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-compass-line text-white text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Calling Clarification</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-[#b8144a] mt-1"></i>
                  <span>Gift identification and development</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-[#b8144a] mt-1"></i>
                  <span>Ministry assignment clarity</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-[#b8144a] mt-1"></i>
                  <span>Vision and purpose alignment</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-[#b8144a] mt-1"></i>
                  <span>Apostolic commissioning</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Mentorship Model */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=One-on-one%20spiritual%20mentorship%20session%20with%20experienced%20minister%20guiding%20young%20leader%2C%20biblical%20discipleship%20meeting%20with%20open%20Bibles%20and%20prayer%2C%20apostolic%20mentoring%20relationship%20showing%20wisdom%20transfer%2C%20warm%20intimate%20setting%20representing%20spiritual%20father%20and%20son%20relationship%20in%20ministry&width=600&height=500&seq=mentorship-model-1&orientation=landscape"
                alt="Mentorship Model"
                className="rounded-lg shadow-2xl object-cover w-full h-96"
              />
            </div>
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Apostolic Mentorship Model</h2>
              <div className="prose prose-lg text-gray-700">
                <p className="text-xl leading-relaxed mb-6">
                  One Fold Network operates on the biblical model of spiritual fathers and mothers raising 
                  spiritual sons and daughters. Each emerging leader is paired with an experienced mentor 
                  who provides guidance, accountability, and spiritual covering.
                </p>
                <div className="bg-[#b8144a] text-white p-6 rounded-lg mb-6">
                  <h3 className="text-xl font-bold mb-4">Mentorship Features</h3>
                  <ul className="space-y-2">
                    <li>• One-on-one spiritual guidance</li>
                    <li>• Regular accountability sessions</li>
                    <li>• Practical ministry training</li>
                    <li>• Character development focus</li>
                    <li>• Calling clarification process</li>
                    <li>• Leadership skill building</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Global Network */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Global Leadership Network</h2>
            <p className="text-xl text-gray-600">Connecting leaders across continents for Kingdom impact</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <i className="ri-earth-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Continental Networks</h4>
              <p className="text-gray-600 text-sm">Regional leadership structures across all continents</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <i className="ri-group-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Leadership Cohorts</h4>
              <p className="text-gray-600 text-sm">Peer learning groups for emerging leaders</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <i className="ri-video-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Virtual Training</h4>
              <p className="text-gray-600 text-sm">Online leadership development programs</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <i className="ri-calendar-event-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Leadership Summits</h4>
              <p className="text-gray-600 text-sm">Annual gatherings for network leaders</p>
            </div>
          </div>
        </div>
      </section>

      {/* Join One Fold Network */}
      <section className="py-20 bg-[#b8144a] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Join One Fold Network</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Are you called to leadership? Ready to be mentored and equipped for greater ministry impact? 
            Join the One Fold Network and become part of the global leadership formation process.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/join"
              className="bg-white text-[#b8144a] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Apply for Leadership Track
            </Link>
            <Link 
              to="/training"
              className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-[#b8144a] transition-colors whitespace-nowrap cursor-pointer"
            >
              Start with GTMP
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}